import Mixin from '@ember/object/mixin';
const Enumerable = Mixin.create();
export default Enumerable;